import { 
    CreatePackageDto, 
    DeletePackageDto,
    EditPackageDto,
    GetPackageDto, 
    MessageResponseDto, 
    PackageApiFp,
    PackageControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponsePackageModel = PackageControllerGet200Response;
export type GetPackageModel = GetPackageDto;
export type MutateResponsePackageModel = MessageResponseDto;
export type CreatePackageModel = CreatePackageDto;
export type UpdatePackageModel = EditPackageDto;
export type DeletePackageModel = DeletePackageDto;

export const apiPackageFp = PackageApiFp(apiConfig);
export const getPackageController = apiPackageFp.packageControllerGet;
export const createPackageController = apiPackageFp.packageControllerCreate;
export const updatePackageController = apiPackageFp.packageControllerEdit;
export const deletePackageController = apiPackageFp.packageControllerDelete;

export const QueryKeyPackage = QueryKey.Package;